// CAPABILITY: Account route — profile/auth edits + billing access.
import React, { useState } from "react";
import Navbar from "../components/NavBar";
import AccountSettings from "../containers/Account/AccountSettings";
import ApiKeySettings from "../containers/Account/ApiKeySettings";
import BillingModal from "../containers/Billing/BillingModal";
import { useAuth } from "../contexts/AuthContext";

export default function AccountPage() {
  const { isSubscribed, chatEntitled } = useAuth();
  const [isBillingOpen, setIsBillingOpen] = useState(false);

  return (
    <div className="app-shell">
      <Navbar />

      <main className="page-container">
        <div className="mx-auto w-full max-w-2xl space-y-6">
          <div>
            <h1 className="text-3xl font-semibold tracking-tight text-slate-950">Account</h1>
            <p className="mt-1 text-sm text-slate-500">
              Manage your sign-in details and subscription.
            </p>
          </div>

          <AccountSettings />

          <ApiKeySettings onOpenBilling={() => setIsBillingOpen(true)} />

          {/* Billing (moved here from the top navigation) */}
          <section className="rounded-xl border border-slate-200 bg-white p-5">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h3 className="text-base font-semibold text-slate-950">Billing &amp; plan</h3>
                <p className="mt-1 text-sm text-slate-500">
                  {isSubscribed
                    ? `You're subscribed${chatEntitled ? " (chat included)" : ""}. Manage or switch your plan.`
                    : "Subscribe to unlock unlimited published pages and live viewer chat."}
                </p>
              </div>
              <button type="button" className="primary-button" onClick={() => setIsBillingOpen(true)}>
                {isSubscribed ? "Manage billing" : "View plans"}
              </button>
            </div>
          </section>
        </div>
      </main>

      <BillingModal isOpen={isBillingOpen} onClose={() => setIsBillingOpen(false)} />
    </div>
  );
}
